import React from 'react'
import { baseContainer } from './MainLayout.module.scss'

const BaseLayout: React.FC = ({ children }) => {
  return <div className={baseContainer}>{children}</div>
}

export default BaseLayout
